import { FeatureName, getFeatureSelector } from "common/Split";
import { RootState } from "RootReducer";

export const selectIpbFeatureOn = (state: RootState) => {
  const isSmbAccelerateOn = getFeatureSelector(FeatureName.SmbAccelerate)(state);
  const isSmbAccelerateIpb = getFeatureSelector(FeatureName.SmbAccelerateIpb)(state);
  return isSmbAccelerateOn && isSmbAccelerateIpb;
};
